import React, { useState, useEffect, useCallback, useRef } from 'react';
import './generate-doc.scss';
import { Button } from 'devextreme-react/button';
import {generate, getTemplateById} from '../../api/api'
import { useAuth } from '../../contexts/auth';
import notify from 'devextreme/ui/notify';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { Form, Label, SimpleItem, RequiredRule, ButtonItem
} from 'devextreme-react/form';

export default function GenerateDocQuestions() {
  const { user, refreshSession } = useAuth();
  let { template_id } = useParams();
  const navigate = useNavigate();

  const formRef = useRef(null);

  const [questions, setQuestions] = useState([]);
  const [qa, setQA] = useState({});
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);

  const onSuccess = useCallback((data) => {
    setGenerating(false);
    navigate("/generate/edit/"+data.document_id)
  }, [navigate])

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      setLoading(false);
      setGenerating(false);
      console.log(error);
    }
  }, [refreshSession]);

  const generateDoc = useCallback(() => {
    setGenerating(true);
    var data = {}
    data['qa'] = Object.keys(qa).map((key) => {return {"question":key, "answer":qa[key]}});
    data['template_id'] = template_id
    generate(user, data, onSuccess, onError);
  }, [qa, template_id, user, onSuccess, onError])

  const onTemplateDataSuccess = useCallback((data) => {
    setQuestions(data.questions)
    setLoading(false);
  }, [])

  useEffect(() => {
    if (user.signInUserSession) {
      getTemplateById(user, template_id, onTemplateDataSuccess, onError)
    }
  }, [user, template_id, onTemplateDataSuccess, onError]);

  const onFormDataChanged = useCallback((e) => {
    qa[e.dataField]=e.value
    setQA(qa)
  }, [qa, setQA])

  /*
  const TabPanelItem = ({ data }) => {
    console.log("TabPanelItem");
    console.log(data);
    return <div className="tabpanel-item" style={{maxHeight:"72vh"}}>{
      generating?
      <div style={{minHeight:"72vh"}}>
        <div className="d-flex flex-row justify-content-center align-items-center pt-5 pb-5">
          Please wait. This may take up to 1 minute...
        </div>
        <div className="d-flex flex-row justify-content-center align-items-center">
            <LoadIndicator
                id="large-indicator"
                height={60}
                width={60}
            />
        </div>
      </div>
      :
      data.children}</div>;
  }*/



  return (
    <React.Fragment>
      {loading?
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
          <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
          />
      </div>
      :
      <div className="d-flex flex-column">
        <div className="d-flex flex-row justify-content-between align-items-end">
          <div className="pe-3" style={{minWidth:"60%"}}>
            <h2 className={'content-block'}>Generate Document</h2>
          </div>
          <Button
              text="Cancel"
              icon="fas fa-chevron-left"
              onClick={() => {navigate("/templates")}}
          />
        </div>
        <hr/>
        {generating?
        <div style={{minHeight:"72vh"}}>
          <div className="d-flex flex-row justify-content-center align-items-center pt-5 pb-5">
            Please wait. This may take up to 1 minute...
          </div>
          <div className="d-flex flex-row justify-content-center align-items-center">
              <LoadIndicator
                  id="large-indicator"
                  height={60}
                  width={60}
              />
          </div>
        </div>:
        <div className="p-3" style={{height:"73vh", overflowY:"scroll"}}>
          <Form
            ref={formRef}
            id={'form'}
            formData={qa}
            onFieldDataChanged={onFormDataChanged}
            labelMode="floating"
          >
            {questions.map((item) => (
              <SimpleItem
                key={item}
                dataField={item}
              >
                <Label text={item}/>
                <RequiredRule message="Answer is required" />
              </SimpleItem>
            ))}
            <ButtonItem buttonOptions={{
              text: 'Generate',
              type: 'default',
              onClick: generateDoc,
              width: '120px',
            }} />
          </Form>
        </div>}
      </div>}

    </React.Fragment>
)}
